export const contentDict = {
  title: "EthicAI (eh·thuh·kl)",                // Display name
  finishDate: new Date("2023-05-19"),     // format is YYYY-MM-DD
  tools: {                                // Dict of languages and percentages (should add up to 1)
    "Python": 0.3,
    "Prompting": 0.3, 
    "Streamlit": 0.2, 
    "OpenAI API": 0.1, 
    "Cohere API": 0.1, 
  }, 
  description: 
    `An interactive ideation assistant with built-in risk assesment.
     We used LLMs to evaluate ethics-dimensions in AI EdTech and [won TUM-Science-Hack 2023's 3rd place](https://www.linkedin.com/posts/tum-junge-akademie_welovewhatwedo-tumja-tum-activity-7066153970976579585-M_or?utm_source=share&utm_medium=member_desktop).`,
  tags: ["Ethics in EdTech", "LLM", "WebApp", "Hackathon"],
  github: "https://github.com/TUM-Science-Hack-2023/ethicAI",    // Can also be `null`
  website: null,       // Can also be `null`
  images: [
    // Use the "raw URL format" to link to imgs in a github repo (https://stackoverflow.com/questions/10935763/github-picture-path)
    'https://github.com/TUM-Science-Hack-2023/ethicAI/raw/main/media/chat-phone.png',
    'https://github.com/TUM-Science-Hack-2023/ethicAI/raw/main/media/eval-metrics-phone.png',
    'https://github.com/TUM-Science-Hack-2023/ethicAI/raw/main/media/risks-phone.png',
    // 'https://github.com/TUM-Science-Hack-2023/ethicAI/raw/main/media/logo-large.jpg'
  ],
  coverImg: 'https://github.com/TUM-Science-Hack-2023/ethicAI/raw/main/media/chat-phone.png',
  mainColor: "#284e12",
  authors: ["Philipp Wulff"],
  isResearch: false,    // Whether should be in the research section
};

// export default contentDict;
// module.exports = { contentDict: 'contentDict' }